export { default as Female } from './Female';
export { default as LogoTypeFa } from './LogoTypeFa';
export { default as Logo } from './Logo';
export { default as Male } from './Male';
export { default as TypeFa } from './TypeFa';
export { default as TourGuide } from './TourGuide';
export { default as StandardPlus } from './StandardPlus';
export { default as Immigration } from './Immigration';

export { default as Tours } from './Tours';
